import { createAction } from '../../@common/actions/action';
import { APP_SET_SETTINGS } from '../constants/settings';

export type SettingsPayload = {
  [key: string]: string | any;
};

export const setSettings = createAction<SettingsPayload>(APP_SET_SETTINGS);
